import { displayLabelForVehicle, isGeneralProductModels, isProductCompatible, loadVehicle } from "@theme/kenteken-api";
//#region assets/vp-vehicle-fit.ts
/**
* Updates `[data-vp-vehicle-fit]` badges from session vehicle + product metafields.
*/
/**
* @param {HTMLElement} root
*/
function renderFit(root) {
	let models = [];
	try {
		models = JSON.parse(root.dataset.productModels || "[]");
	} catch {
		models = [];
	}
	if (!Array.isArray(models)) models = models ? [models] : [];
	if (isGeneralProductModels(models)) {
		root.hidden = true;
		delete root.dataset.state;
		return;
	}
	const vehicle = loadVehicle();
	const labelEl = root.querySelector("[data-vp-vehicle-fit-label]");
	const dot = root.querySelector("[data-vp-vehicle-fit-dot]");
	if (!labelEl) return;
	if (!vehicle || !(vehicle.brandAndModel || vehicle.brandAndModels?.length)) {
		const fallback = root.dataset.fallbackLabel || "";
		if (!fallback) {
			root.hidden = true;
			delete root.dataset.state;
			return;
		}
		root.hidden = false;
		root.dataset.state = "unknown";
		labelEl.textContent = fallback;
		return;
	}
	const compatible = isProductCompatible(models, vehicle);
	root.hidden = false;
	root.dataset.state = compatible ? "compatible" : "incompatible";
	const vehicleLabel = displayLabelForVehicle(vehicle) || "uw voertuig";
	const template = compatible ? root.dataset.compatibleLabel || "Past op uw voertuig" : root.dataset.incompatibleLabel || "Mogelijk niet geschikt voor uw voertuig";
	labelEl.textContent = template.includes("%s") ? template.replace("%s", vehicleLabel) : compatible ? `${template.replace(/\.*$/, "")} (${vehicleLabel})` : template;
	if (dot) dot.dataset.state = compatible ? "compatible" : "incompatible";
}
function refreshAll() {
	document.querySelectorAll("[data-vp-vehicle-fit]").forEach((root) => {
		if (root instanceof HTMLElement) renderFit(root);
	});
}
function init() {
	if (window.__vpVehicleFitReady) {
		refreshAll();
		return;
	}
	window.__vpVehicleFitReady = true;
	refreshAll();
	window.addEventListener("vp-vehicle:change", refreshAll);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
else init();
//#endregion
